// The server operates on buy-in indexes into this list of available buy-in options.
// We can show different buy-in amounts to choose from when creating a game,
// but must look up the index in this list when creating an outbound:
export const ALL_BUY_IN_AMOUNTS = [
    500, 1000, 1500, 2000, 2500, 3000, 3500, 4500, 5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000,
    25000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 125000, 150000, 175000, 200000, 300000,
    400000, 500000, 750000, 1000000, 2000000, 3000000, 4000000, 5000000
];
// Show a subset of the total buy-in options that the server supports:
export const AVAILABLE_BUY_IN_AMOUNTS = [
    500, 1000, 1500, 2000, 2500,
    // 3_000,
    // 3_500,
    // 4_500,
    5000,
    // 6_000,
    // 7_000,
    // 8_000,
    // 9_000,
    10000,
    // 15_000,
    20000,
    // 25_000,
    // 30_000,
    // 40_000,
    50000,
    // 60_000,
    // 70_000,
    // 80_000,
    // 90_000,
    100000,
    // 125_000,
    // 150_000,
    // 175_000,
    200000, 300000,
    // 400_000,
    500000,
    // 750_000,
    1000000, 2000000,
    // 3_000_000,
    // 4_000_000,
    5000000
];
